module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/assessment_achievements/6_98b35ec2b79926f01a5331e7bdabc5ca.gif";